/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { GmaoLineChartController } from './GmaoLineChart';

class GmaoActionRequestsByStatusChartController extends GmaoLineChartController {
    /** @ngInject */
    constructor($log, configuration, $translate) {
        super($log, configuration);
        this.$translate = $translate;
        this.$log.debug('Controller \'GmaoActionRequestsByStatusChart\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.chartOptions.chart.margin.left = 30;
        this.chartOptions.chart.color = [
            this.configuration.CHART_COLORS.ACTION_REQUEST_OPENED,
            this.configuration.CHART_COLORS.ACTION_REQUEST_COMPLETED,
            this.configuration.CHART_COLORS.ACTION_REQUEST_CLOSED,
            this.configuration.CHART_COLORS.ACTION_REQUEST_CANCELED
        ];
        this.chartOptions.chart.xAxis = {
            tickValues: series => {
                // Values for the X axis are the same whatever the serie used. Then, we used the first serie to get
                // these values.
                let tickValues;
                if (series.length > 0) {
                    tickValues = series[0].values.map(value => value.x);
                } else {
                    tickValues = [];
                }
                return tickValues;
            },
            tickFormat: value => d3.time.format('%m-%Y')(new Date(value)),
            staggerLabels: true
        },
        this.chartOptions.chart.yDomain = [0, this.resolveMaxY()];
        this.chartOptions.chart.showValues = true;

        this.chartData = this.data;
    }

    /**
     * Resolves the maximum Y value in all series of points.
     *
     * @return {Number} Maximum Y value.
     */
    resolveMaxY() {
        let maxY = 0;
        this.data.forEach(serie => {
            serie.values.forEach(value => {
                maxY = Math.max(maxY, value.y);
            })
        })
        return maxY;
    }
}

export const gmaoActionRequestsByStatusChartComponent = {
    controller: GmaoActionRequestsByStatusChartController,
    template: require('./gmao-chart.html'),
    bindings: {
        data: '='
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/component/GmaoActionRequestsByStatusChart.js